/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './UpdateLog.css';

let list = [
  {
    title:'2017.12.07更新',
    cont:[
      {
        link:'/chomion',
        txt:'优化了时间选择模块，现在点击非日历区域也可以关闭'
      },{
        link:'/',
        txt:'修复了若干bug'
      }
    ]
  },
  {
    title:'2017.12.05更新',
    cont:[
      {
        link:'/dashboard',
        txt:'优化了详情页品牌跳转'
      },{
        link:'/mindshare',
        txt:'优化了对比页，现在添加的对比品牌始终出现在第二个位置，位于对比品牌列表的第一个品牌不能删除，在品牌只有一个时会出现文章模块'
      },{
        link:'/algorithm',
        txt:'更新了算法介绍页'
      },{
        link:'/geo',
        txt:'优化了地理榜，现在会出现所有省份，未有数据省份字体颜色为灰色，不可点击'
      },{
        link:'/',
        txt:'首页banner图可以自动轮播啦！'
      }
    ]
  },
  {
    title:'2017.12.01更新',
    cont:[
      {
        link:'/register',
        txt:'优化了注册界面错误提示，现在是每次移出输入框都会出现友好的提示'
      },{
        link:'/forgetpwd',
        txt:'优化了修改密码界面'
      }
    ]
  },
  {
    title:'2017.11.30更新',
    cont:[
      {
        link:'/dashboard',
        txt:'优化了性能，正在输入对比品牌时，口碑舆情图不会重复加载'
      },{
        link:'/',
        txt:'优化了搜索框，现在自动补全框更加好看，支持点击搜索图标进行搜索'
      }
    ]
  },
  {
    title: '2017.11.28更新',
    cont: [
      {
        link: '/dashboard',
        txt: '修复了修改所在公司后不能正确匹配公司的bug，现在是点击品牌详情都会显示公司品牌或者demo品牌',
      }, {
        link: '/dashboard',
        txt: '修复了关键事件跟KOL关联的不更改的问题'
      }

    ]

  }
]

class UpdateLog extends React.Component {

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>更新日志</h1>
          <div>
            {list.map((item, i) => {
              return (
                <div key={i} className={s.day}>
                  <h2>{item.title}</h2>
                  <ol>{item.cont.map(i=>
                    <li key={i.txt}><p>{i.txt}<a href={i.link} target='_blank'>详情</a></p></li>
                  )}
                  </ol>
                </div>
              )

            })}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(UpdateLog);



// WEBPACK FOOTER //
// src/routes/updateLog/UpdateLog.js